module.exports = __webpack_public_path__ + "media/applicants/right-arrow-29-fb25f47d.svg";